export const asyncJobTypes = [
  {
    value: 2,
    label: "Activate clients",
  },
  {
    value: 3,
    label: "Deactivate clients",
  },
  {
    value: 4,
    label: "Set Escalated",
  },
  {
    value: 5,
    label: "Set Approved High Risk",
  },
  {
    value: 6,
    label: "Set Rejected High Risk",
  },
  {
    value: 7,
    label: "Recalculate clients",
  },
  {
    value: 9,
    label: "Rescore clients",
  },
  {
    value: 10,
    label: "Negative media",
  },
  {
    value: 11,
    label: "Semantic Negative Media",
  },
  {
    value: 12,
    label: "Watchlist Regular Search",
  },
];

export const asyncJobTypes_coordinator = [
  {
    value: 2,
    label: "Activate clients",
  },
  {
    value: 3,
    label: "Deactivate clients",
  },
  {
    value: 4,
    label: "Set Escalated",
  },
  {
    value: 5,
    label: "Set Approved High Risk",
  },
  {
    value: 6,
    label: "Set Rejected High Risk",
  },
  {
    value: 7,
    label: "Recalculate clients",
  },
  {
    value: 9,
    label: "Rescore clients",
  },
  {
    value: 10,
    label: "Negative media",
  },
  {
    value: 12,
    label: "Watchlist Regular Search",
  },
];

export const asyncJobTypes_manager = [
  {
    value: 2,
    label: "Activate clients",
  },
  {
    value: 3,
    label: "Deactivate clients",
  },
  {
    value: 4,
    label: "Set Escalated",
  },
  {
    value: 5,
    label: "Set Approved High Risk",
  },
  {
    value: 6,
    label: "Set Rejected High Risk",
  },
  {
    value: 7,
    label: "Recalculate clients",
  },
  {
    value: 9,
    label: "Rescore clients",
  },
  {
    value: 10,
    label: "Negative media",
  },
  {
    value: 12,
    label: "Watchlist Regular Search",
  },
];

export const exportTypes = [
  {
    value: 1,
    label: "Multi client report",
  },
  {
    value: 8,
    label: "MonitoringQueue export",
  },
];

export const asyncJobFinished = [
  {
    value: 0,
    label: "Error",
  },
  {
    value: 1,
    label: "Success",
  },
  {
    value: 2,
    label: "Unfinished",
  },
];

export const asyncJobResultTypes = [
  {
    value: 0,
    label: "None",
  },
  {
    value: 1,
    label: "Success",
  },
  {
    value: 2,
    label: "Error",
  },
  {
    value: 3,
    label: "JSON",
  },
  {
    value: 4,
    label: "HTML",
  },
  {
    value: 5,
    label: "CSV",
  },
  {
    value: 6,
    label: "PDF",
  },
  {
    value: 7,
    label: "Excel",
  },
];

export const ASYNC_JOBS_INITIAL_FILTERS = {
  dateFrom: "",
  dateTo: "",
  jobType: "",
  jobResultType: "",
  finished: "",
};

export const ASYNC_JOBS_FILTER_LABELS = {
  dateFrom: "Date From:",
  dateTo: "Date To:",
  jobType: "Job type:",
  jobResultType: "Job result type:",
  finished: "Status:",
};



// WEBPACK FOOTER //
// ./src/features/organization/constants/asyncJobsConstants.js